export default __webpack_public_path__ + "static/media/lesson_collapse_arrow.9821ad25.svg";